<div class="container">

    <app-header-dialog [iconName]="'people_outline'">
    GN1
  </app-header-dialog>


  <div class="content">

    <div class="box">
      <div class="label">
        Nome:
      </div>
      <div class="value">
        {{member.name}}
      </div>
    </div>

    <div class="box">
      <div class="label">
        Categoria:
      </div>
      <div class="value">
        {{member.category}}
      </div>
    </div>

    <div class="box">
      <div class="label">
        Situação:
      </div>
      <div class="value">
        {{member.situation}}
      </div>
    </div>

    <div class="box">
      <div class="label">
        Endereço:
      </div>
      <div class="value">
        {{member.address}},  {{member.number}}, {{member.complement}} - {{member.district}} -  {{member.city}},  {{member.state}} - {{member.postalCode}}
      </div>
    </div>

    <div class="box">
      <div class="label">
        E-mails:
      </div>
      <div class="value">
        {{member.email}} // {{member.email2}}
      </div>
    </div>

    <div class="box">
      <div class="label">
        Celular:
      </div>
      <div class="value">
        {{member.cellPhone}}
      </div>
    </div>

    <div class="box">
      <div class="label">
        FAX:
      </div>
      <div class="value">
        {{member.faxPhone}}
      </div>
    </div>

    <div class="box">
      <div class="label">
        Clinica:
      </div>
      <div class="value">
        {{member.clinicPhone}}
      </div>
    </div>

    <div class="box">
      <div class="label">
        Hospital:
      </div>
      <div class="value">
        {{member.hospitalPhone}}
      </div>
    </div>

    <div class="box">
      <div class="label">
        Auxiliares:
      </div>
      <div class="value">
        {{member.auxPhone1}}  //  {{member.auxPhone2}}
      </div>
    </div>

    <div class="box">
      <div class="label">
        RG:
      </div>
      <div class="value">
        {{member.rg}}
      </div>
    </div>

    <div class="box">
      <div class="label">
        CPF:
      </div>
      <div class="value">
        {{member.cpf}}
      </div>
    </div>

    <div class="box">
      <div class="label">
        CRM:
      </div>
      <div class="value">
        {{member.crm}}
      </div>
    </div>

    <div class="box">
      <div class="label">
        Nascimento:
      </div>
      <div class="value">
        {{member.birthDate}}
      </div>
    </div>

    <div class="box">
      <div class="label">
        Filiação:
      </div>
      <div class="value">
        {{member.filiationDate}}
      </div>
    </div>

    <div class="box">
      <div class="label">
        Título:
      </div>
      <div class="value">
        {{member.titleDate}}
      </div>
    </div>

    <div class="box">
      <div class="label">
        Insituição:
      </div>
      <div class="value">
        {{member.institute}}
      </div>
    </div>

    <div class="box">
      <div class="label">
        Regional:
      </div>
      <div class="value">
        {{member.regional}}
      </div>
    </div>

    <div class="box">
      <div class="label">
        Gênero:
      </div>
      <div class="value">
        {{member.gender}}
      </div>
    </div>

    <div class="box">
      <div class="label">
        Conselho:
      </div>
      <div class="value">
        {{member.concilState}}
      </div>
    </div>

    <div class="box">
      <div class="label">
        Especialização:
      </div>
      <div class="value">
        {{member.specialization}}
      </div>
    </div>


  </div>



</div>